import {Routes, Route} from "react-router-dom";
import VerifyAccount from "../VerifyAccount/VerifyAccount";
import Verify2FAHandler from "../VerifyAccount/Verify2FA"
import LoginComponent from "./LoginComponent";
import TwoFactorAuth from "./TwoFactorAuth";
import Signup from "./Signup";
import RateAppt from "../PatientComponents/RateAppt"
import {useAppContext} from "../../AppContext";
import ForgotPasswordComponent from "../ResetPassword/ResetPasswordComponent";
import React, {useState} from "react";
import ResetPassword from "./ResetPassword";


export default function Login() {
  const {isLoading, setIsLoading} = useAppContext();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertStatus, setAlertStatus] = useState("error");

  const showAlert = (message, status = "error") => {
    setAlertMessage(message);
    setAlertStatus(status);
    setIsAlertVisible(true);
  }

  const hideAlert = () => setIsAlertVisible(false);

  return (<div className="App">
    <Routes>
      <Route path="/signup" element={<Signup/>}/>
      <Route path="/rateappt" element={<RateAppt/>}/>
      <Route path="/verify/:tokenId" element={<VerifyAccount/>}/>
      <Route path="/reset-password/:tokenId" element={<ResetPassword/>}/>
      <Route path="/forgot_password" element={<ForgotPasswordComponent
        isAlertVisible={isAlertVisible}
        alertMessage={alertMessage}
        alertStatus={alertStatus}
        showAlert={showAlert}
        hideAlert={hideAlert}
      />}/>
      <Route
        path="*"
        element={<LoginComponent
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isAlertVisible={isAlertVisible}
          alertMessage={alertMessage}
          alertStatus={alertStatus}
          showAlert={showAlert}
          hideAlert={hideAlert}
        />}
      />
      <Route path="/two-factor-auth" element={<TwoFactorAuth
        isAlertVisible={isAlertVisible}
        alertMessage={alertMessage}
        alertStatus={alertStatus}
        showAlert={showAlert}
        hideAlert={hideAlert}
      />}/>
      <Route path="/verify2fa" element={<Verify2FAHandler/>}/>
    </Routes>
  </div>);
}